// extracted by mini-css-extract-plugin
module.exports = {"SobreNos-container":"SobreNos_SobreNos-container__3gwv0"};